import cx from "classnames"
import type React from "react"

export type ModalFooterPropsType = {
  children?: React.ReactNode
  className?: string
}

const ModalFooter = ({ children, className }: ModalFooterPropsType) => {
  return <div className={cx("cobalt-modal-footer", className)}>{children}</div>
}

export default ModalFooter
